export default __webpack_public_path__ + "static/media/le_neubourg.2a1df604.jpg";